import { Box } from "@mui/material";
import ChatFlutuant from "../../components/ChatFlutuant";
import MenuLateral from "../../components/MenuLateral";
import Header from "../../components/header";
import IconProduct from "../../componentsStyled/icon/iconproduct";
import IconExterno from "../../componentsStyled/icon/iconexterno";
import IconIntimo from "../../componentsStyled/icon/iconintimo";
import IconKits from "../../componentsStyled/icon/iconkits";
import HeaderMobile from "../../components/headerMobile";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function InfoData() {
  const settings = {
    dots: true,
    arrow: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // adaptiveHeight: true,
  };
  return (
    <>
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <Header />
        <Box display={"flex"} width={"100%"} justifyContent={"center"} mt={5}>
          <MenuLateral currentPage="info" />
          <Box width={"100%"} ml={2} pb={5}>
            <p style={{ fontWeight: 400, fontSize: 20, fontFamily: "Helvetica" }}>Informações e Instruções</p>
            <Box display={"flex"} justifyContent={"center"} mt={5}>
              <p style={{ fontWeight: 400, fontFamily: "Helvetica Neue", fontSize: 18, width: 300, textAlign: "center" }}>
                Veja como é simples e rápido realizar a devolução do seu produto:
              </p>
            </Box>
            <Box display={"flex"} gap={7} justifyContent={"center"} mt={7}>
              {/* item */}
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                  <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>1</span>
                </Box>
                <p>Selecione o pedido e produto que deseja;</p>
              </Box>
              {/* item */}
              {/* item */}
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                  <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>2</span>
                </Box>
                <p>Insira as informações e motivos da devolução;</p>
              </Box>
              {/* item */}
              {/* item */}
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                  <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>3</span>
                </Box>
                <p>Escolha a forma de reembolso que preferir;</p>
              </Box>
              {/* item */}
            </Box>

            <Box display={"flex"} gap={20} justifyContent={"center"} mt={5}>
              {/* item */}
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                  <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>4</span>
                </Box>
                <p>Selecione a forma de envio;</p>
              </Box>
              {/* item */}
              {/* item */}
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                  <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>5</span>
                </Box>
                <p>Acompanhe o progresso!</p>
              </Box>
              {/* item */}
            </Box>

            <Box display={"flex"} justifyContent={"center"} marginY={5}>
              <p style={{ fontWeight: 700 }}>... e fique de olho!</p>
            </Box>

            <Box display={"flex"} gap={5} justifyContent={"center"} flexWrap={'wrap'}>
              <Box
                bgcolor={"#fff"}
                border={"1px solid #E0E0E0"}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                width={250}
                p={3}
                borderRadius={3}>
                <IconProduct width={96} />
                <p style={{ textAlign: "center" }}>O Produto não pode apresentar sinais de uso, com manchas, sujeira ou suor.</p>
              </Box>
              <Box
                bgcolor={"#fff"}
                border={"1px solid #E0E0E0"}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                width={250}
                p={3}
                borderRadius={3}>
                <IconExterno width={96} />
                <p style={{ textAlign: "center" }}>Preserve as embalagens internas e externas do produto.</p>
              </Box>
              <Box
                bgcolor={"#fff"}
                border={"1px solid #E0E0E0"}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                width={250}
                p={3}
                borderRadius={3}>
                <IconIntimo width={96} />
                <p style={{ textAlign: "center" }}>Não é possível realizar a troca de roupas íntimas e de compressão.</p>
              </Box>
              <Box
                bgcolor={"#fff"}
                border={"1px solid #E0E0E0"}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                width={250}
                p={3}
                borderRadius={3}>
                <IconKits width={96} />
                <p style={{ textAlign: "center" }}>Não é possível fazer a troca de itens individuais de kits prontos.</p>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* desktop */}

      {/* Mobile */}
      <Box display={{ xs: "initial", md: "none" }}>
        <HeaderMobile currentPage="info" />
        <Box ml={1} mr={1}>
          <p style={{ fontWeight: 400, fontSize: 20, fontFamily: "Helvetica" }}>Informações e Instruções</p>
          <Box display={"flex"} justifyContent={"center"} mt={5}>
            <p style={{ fontWeight: 400, fontFamily: "Helvetica Neue", fontSize: 18, width: 300, textAlign: "center" }}>
              Veja como é simples e rápido realizar a devolução do seu produto:
            </p>
          </Box>

          <Box display={"flex"} flexDirection={"column"} gap={5} justifyContent={"center"} mt={7}>
            {/* item */}
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>1</span>
              </Box>
              <p>Selecione o pedido e produto que deseja;</p>
            </Box>
            {/* item */}
            {/* item */}
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>2</span>
              </Box>
              <p>Insira as informações e motivos da devolução;</p>
            </Box>
            {/* item */}
            {/* item */}
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>3</span>
              </Box>
              <p>Escolha a forma de reembolso que preferir;</p>
            </Box>
            {/* item */}
            {/* item */}
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>4</span>
              </Box>
              <p>Selecione a forma de envio;</p>
            </Box>
            {/* item */}
            {/* item */}
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <Box bgcolor={"#C2282B"} borderRadius={100} width={40} height={40} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                <span style={{ color: "#fff", fontFamily: "Helvetica Neue", fontWeight: 500, fontSize: 20 }}>5</span>
              </Box>
              <p>Acompanhe o progresso!</p>
            </Box>
            {/* item */}
          </Box>

          <Box display={"flex"} justifyContent={"center"} marginY={5}>
            <p style={{ fontWeight: 700 }}>... e fique de olho!</p>
          </Box>

          <Box width={"90%"} margin={"0 auto"}>
            <Slider {...settings}>
              <Box>
                <Box
                  bgcolor={"#fff"}
                  border={"1px solid #E0E0E0"}
                  borderRadius={3}
                  p={3}
                  display={"flex"}
                  flexDirection={"column"}
                  width={"70vw"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  textAlign={"center"}>
                  <IconProduct width={96} />
                  <p style={{ textAlign: "center" }}>O Produto não pode apresentar sinais de uso, com manchas, sujeira ou suor.</p>
                </Box>
              </Box>
              <Box>
                <Box
                  bgcolor={"#fff"}
                  border={"1px solid #E0E0E0"}
                  borderRadius={3}
                  p={3}
                  display={"flex"}
                  flexDirection={"column"}
                  width={"70vw"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  textAlign={"center"}>
                  <IconExterno width={96} />
                  <p style={{ textAlign: "center" }}>Preserve as embalagens internas e externas do produto.</p>
                </Box>
              </Box>
              <Box>
                <Box
                  bgcolor={"#fff"}
                  border={"1px solid #E0E0E0"}
                  borderRadius={3}
                  p={3}
                  display={"flex"}
                  flexDirection={"column"}
                  width={"70vw"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  textAlign={"center"}>
                  <IconIntimo width={96} />
                  <p style={{ textAlign: "center" }}>Não é possível realizar a troca de roupas íntimas e de compressão.</p>
                </Box>
              </Box>
              <Box>
                <Box
                  bgcolor={"#fff"}
                  border={"1px solid #E0E0E0"}
                  borderRadius={3}
                  p={3}
                  display={"flex"}
                  flexDirection={"column"}
                  width={"70vw"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  textAlign={"center"}>
                  <IconKits width={96} />
                  <p style={{ textAlign: "center" }}>Não é possível fazer a troca de itens individuais de kits prontos.</p>
                </Box>
              </Box>
            </Slider>
          </Box>
          <Box marginY={15} />
        </Box>
      </Box>
      {/* Mobile */}

      <ChatFlutuant />
    </>
  );
}
